import { apiPostBlob } from "@/lib/apiClient";
import toast from "react-hot-toast";

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Exports the Draft Calendar grid to Excel via the backend (mirrors GRC's
 * DownloadGRCReporttoExcel pattern) — the workbook is generated server-side
 * with Telerik RadSpreadProcessing, so there's no client-side zip/Worker/CSP concern.
 * Role/column visibility is resolved server-side from the user's record, not the client.
 */
export async function exportDraftCalendarToExcel(fiscalYearId: number, userEmail: string): Promise<void> {
  const blob = await apiPostBlob(`DownloadDraftCalendarReportToExcel/${fiscalYearId}?userEmail=${encodeURIComponent(userEmail)}`);
  downloadBlob(blob, "DraftCalendar.xlsx");
  toast.success("Export successful");
}
